import { http } from '@/utils'

export const getConfigContact = () => {
  return http({
    url: '/api/config/contact',
  })
}
